'use client'
import axios from 'axios';

const ctrl = {};

ctrl.get = async (cedula, captchaToken) => {
    return axios.get('/api/acuerdo', {
        params: {
            cedularuc: cedula
        },
        headers: {
            'X-Altcha-Token': captchaToken ? captchaToken : ''
        }
    })
};

ctrl.post = async (data) => {
    return axios.post('/api/acuerdo', data)
}

export default ctrl;